import { Nav, Tab } from "react-bootstrap";
import { IIncidentDetails } from "../../../api/IIncident";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import { DocumentsGrid } from "../../../leap-components/Documents/DocumentsGrid";
import EpaCard from "../../../leap-components/EpaCard";
import { IncidentCorrectiveAndPreventativeActions } from "../../../leap-components/Incidents/IncidentCorrectiveAndPreventativeActionsGrid";
import { IncidentEmissionParameterResultsGrid } from "../../../leap-components/Incidents/IncidentEmissionParameterResultsGrid";
import { IncidentUpdateRequestsGrid } from "../../../leap-components/Incidents/IncidentUpdateRequestsGrid";
import { NonCompliancesGrid } from "../../../leap-components/NonCompliances/NonCompliancesGrid";

interface SubTabsProps {
  className?: string;
  activeKey: string;
  incidentDetails: IIncidentDetails;
  licenceProfile: ILicenceProfile;
}

interface RelatecComplianceProps {
  incidentDetails: IIncidentDetails;
  licenceProfile: ILicenceProfile;
}

const SubTabs = ({
  className,
  activeKey,
  incidentDetails,
  licenceProfile,
}: SubTabsProps) => (
  <div className={"tab " + className}>
    <Tab.Container id="left-tabs-example" defaultActiveKey={activeKey}>
      <Nav variant="tabs">
        <Nav.Item>
          <Nav.Link eventKey="emission-parameter-results">
            Emission Parameter Results
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="corrective-preventative-actions">
            Corrective / Preventative Actions
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="update-requests">Update Requests</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="documents">Documents</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="non-compliances">Non Compliances</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="documents">
          <DocumentsGrid regardingObjectId={incidentDetails.incidentid} />
        </Tab.Pane>
        <Tab.Pane eventKey="non-compliances">
          <NonCompliancesGrid
            relatedRecordType="Incident"
            relatedRecordId={incidentDetails.incidentid}
            licenceProfile={licenceProfile}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="corrective-preventative-actions">
          <IncidentCorrectiveAndPreventativeActions
            incidentId={incidentDetails.incidentid}
            licenceProfile={licenceProfile}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="update-requests">
          <IncidentUpdateRequestsGrid
            incidentId={incidentDetails.incidentid}
            licenceProfile={licenceProfile}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="emission-parameter-results">
          <IncidentEmissionParameterResultsGrid
            incidentId={incidentDetails.incidentid}
            licenceProfile={licenceProfile}
          />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  </div>
);

const RelatedComplianceRecords = ({
  incidentDetails,
  licenceProfile,
}: RelatecComplianceProps) => {
  var bodyElements = (
    <SubTabs
      activeKey="emission-parameter-results"
      incidentDetails={incidentDetails}
      licenceProfile={licenceProfile}
    />
  );
  return (
    <EpaCard title={"Related Compliance Records"} content={bodyElements} />
  );
};

export default RelatedComplianceRecords;
